import { createSlice, type PayloadAction, type Slice } from "@reduxjs/toolkit";

import { MediaCommsContactTab, MediaCommsContentKey } from "./mediaComms.general.model";
import { MediaCommsGeneralState } from "./mediaComms.general.state";

const initialState: MediaCommsGeneralState = {
	isExpanded: false,
	mediaCommsContactTab: MediaCommsContactTab.Metrics,
	mediaCommsContentKey: MediaCommsContentKey.General,
	isSearchPanelVisible: false,
};

export const mediaCommsGeneralSlice: Slice = createSlice({
	name: "mediaCommsGeneral",
	initialState,
	reducers: {
		setMediaCommsDockIsExpanded(state, action: PayloadAction<boolean>) {
			state.isExpanded = action.payload;
		},
		setMediaCommsContactTab(state, action: PayloadAction<MediaCommsContactTab>) {
			state.mediaCommsContactTab = action.payload;
		},
		setMediaCommsContentKey(state, action: PayloadAction<MediaCommsContentKey>) {
			state.mediaCommsContentKey = action.payload;
		},
		setIsSearchPanelVisible(state, action: PayloadAction<boolean>) {
			state.isSearchPanelVisible = action.payload;
		},
	},
});

export const {
	setMediaCommsDockIsExpanded,
	setMediaCommsContactTab,
	setMediaCommsContentKey,
	setIsSearchPanelVisible,
} = mediaCommsGeneralSlice.actions;
